<template>
    <span>{{ item.user.tag }} pledged {{ item.amount | currency }}</span>
</template>

<script>
export default {
    props: {
        item: {
            required: true
        }
    }
};
</script>
